import axios, { AxiosError } from 'axios'
import qs from 'qs'

import { injectRefreshTokenToRequest } from '../interceptors/injectRefreshToken'
import { ApiError } from './apiClient'

import { ENV } from '~constants'
import { signOutWhenNotAuthorized } from '~utils'

export const refreshTokenClient = axios.create({
  baseURL: ENV.API_URL,
  timeout: 30 * 1000,
  paramsSerializer: (params) => qs.stringify(params),
})

refreshTokenClient.interceptors.request.use(injectRefreshTokenToRequest, (error) => {
  return Promise.reject(error)
})

refreshTokenClient.interceptors.response.use(
  async (response) => {
    return response?.data?.data
  },
  async (error: AxiosError<ApiError>) => {
    await signOutWhenNotAuthorized(error)
  }
)
